export const batchCalendarTableHead = [
  { field: "serialNumber", headerName: "SL No", width: 60 },
  { field: "name", headerName: "Student Name", minWidth: 250 },
  { field: "admnNo", headerName: "Admission No", minWidth: 250 },
  { field: "attendance", headerName: "Attendance", minWidth: 250 },
];
